import { render, staticRenderFns } from "./PurchaseReceiveSnsList.vue?vue&type=template&id=0d084164&scoped=true"
import script from "./PurchaseReceiveSnsList.vue?vue&type=script&lang=js"
export * from "./PurchaseReceiveSnsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d084164",
  null
  
)

export default component.exports